export default __webpack_public_path__ + "static/media/default.1b3d64467a42f408848d676be78c4d64.png";